import {SystemStyleObject} from '@chakra-ui/react'

const baseStyle: SystemStyleObject = {
    textDecoration: 'none',
}

const hoverUnderline: SystemStyleObject = {
    _hover: {
        textDecoration: 'underline !important',
    },
}

const alwaysUnderline: SystemStyleObject = {
    textDecoration: 'underline !important',
}

const link = {
    Link: {
        baseStyle: baseStyle,
        variants: {
            hoverUnderline,
            alwaysUnderline,
        },
        defaultProps: {
            variant: 'base',
        },
    },
}

export default link
